import React from 'react';
import { locationPath } from '../../helpers/locationHelper';



const Progressbar = (props) => {

  const isListingPage = (locationPath() === 'listing-page' || locationPath() === 'basket-page' || locationPath() === 'paymentdetails-page' || locationPath() === 'confirmation-page') ? 'active': '';
  const isBasketPage = (locationPath() === 'basket-page' || locationPath() === 'paymentdetails-page' || locationPath() === 'confirmation-page') ? 'active': '';
  const isSummaryPage = (locationPath() === 'paymentdetails-page' || locationPath() === 'confirmation-page') ? 'active': '';
  const isComfirmationPage = (locationPath() === 'confirmation-page') ? 'active': '';
  const tourId = (props.tourId === undefined) ? "" : props.tourId;

  return (
    <div className="progressbar">

      <div className="row">
        <div className="column small-12 large-11 large-offset-0-5">
          <ul>

            <li className={(locationPath() === 'listing-page') ? 'mobileActive' : ''}>
              <span className={`${isListingPage}`} ><a href="/">1. Trips</a></span> &nbsp; &nbsp;
              <span className="fa fa-chevron-right"></span>
            </li>

            <li className={(locationPath() === 'basket-page') ? 'mobileActive' : ''}>
              <span className={`${isBasketPage}`} ><a href={`/basket/${tourId}`} className={(locationPath() === 'listing-page') ? 'departure-listing' : ''}>2. Departure</a></span> &nbsp; &nbsp;
                <span className="fa fa-chevron-right"></span>
            </li>

            <li className={(locationPath() === 'paymentdetails-page') ? 'mobileActive' : ''}>
              <span className={`${isSummaryPage}`}>3. Summary </span> &nbsp; &nbsp;
              <span className="fa fa-chevron-right"></span>
            </li>

            <li className={(locationPath() === 'confirmation-page') ? 'mobileActive' : ''}>
              <span className={`${isComfirmationPage}`}>4. Comfirmation </span>
            </li>

          </ul>
        </div>
      </div>
    </div>
  )
}

export default React.memo(Progressbar);


// WEBPACK FOOTER //
// ./src/components/shared/progressbar.js